// eslint-disable-next-line more/no-window
export default window.APP_CONFIG;
